export default "__VITE_PUBLIC_ASSET__e64585e7__"